/**
 * @generated SignedSource<<cb3f621a5997d2409094ced591d2590f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobPosting_Job$data = {
  readonly incognito: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"JobFormWrapper_Job" | "JobPostingContent_Job">;
  readonly " $fragmentType": "JobPosting_Job";
};
export type JobPosting_Job$key = {
  readonly " $data"?: JobPosting_Job$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobPosting_Job">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobPosting_Job",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobPostingContent_Job"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobFormWrapper_Job"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "incognito",
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": null
};

(node as any).hash = "166c5a4d5f671e8a3f4538c78efb4bd3";

export default node;
